import { FullPageLoader } from 'src/components';

export const AuthCheck: React.FC = () => <FullPageLoader />;
